export default __webpack_public_path__ + "static/chemlab-aadca486847cb3ac347bc366d31d1f21.jpg";